module.exports = __webpack_public_path__ + "media/packs/images/flags/NL-a78dffdd2c663e9a2b437cdc45e8ea45.png";